import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { NewRequisitionModalComponent } from './modals/matter-requisition/new-requisition-modal/new-requisition-modal.component';
import { RequisitionPrecedentFormComponent } from './forms/requisition-precedent-form/requisition-precedent-form.component';
import { RequisitionStatusDropdownComponent } from './forms/requisition-precedent-form/requisition-status-dropdown/requisition-status-dropdown.component';
import { CoreModule } from '@core/core.module';
import { NewTeranetRequisitionModalComponent } from './modals/new-teranet-requisition-modal/new-teranet-requisition-modal.component';
import { TeranetInstrumentsRequisitionComponent } from './modals/new-teranet-requisition-modal/teranet-instruments-requisition/teranet-instruments-requisition.component';
import { TeranetWritsRequisitionComponent } from './modals/new-teranet-requisition-modal/teranet-writs-requisition/teranet-writs-requisition.component';
import { RequisitionPrecedentDataComponent } from './requisition-precedent-data/requisition-precedent-data.component';
import { RequisitionTextAreasComponent } from './forms/requisition-precedent-form/requisition-text-areas/requisition-text-areas.component';
import { RequisitionTextColumnComponent } from './forms/requisition-precedent-form/requisition-text-column/requisition-text-column.component';
import { NewCustomRequisitionModalComponent } from './modals/custom-requisition/new-custom-requisition-modal/new-custom-requisition-modal.component';
import { ConfirmDeleteCustomRequisitionComponent } from './modals/custom-requisition/confirm-delete-custom-requisition/confirm-delete-custom-requisition.component';
import { CustomRequisitionFormComponent } from './forms/custom-requisition-form/custom-requisition-form.component';
import { EditCustomRequisitionModalComponent } from './modals/custom-requisition/edit-custom-requisition-modal/edit-custom-requisition-modal.component';
import { NewCustomRequisitionViewComponent } from './modals/custom-requisition/new-custom-requisition-modal/new-custom-requisition-view/new-custom-requisition-view.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RequisitionTagTextValidationDirective } from './directives/requisition-tag-text-validation.directive';
import { UiModule } from 'src/app/ui/ui.module';

@NgModule({
	declarations: [
		RequisitionPrecedentFormComponent,
		RequisitionStatusDropdownComponent,
		NewRequisitionModalComponent,
		TeranetInstrumentsRequisitionComponent,
		TeranetWritsRequisitionComponent,
		NewTeranetRequisitionModalComponent,
		RequisitionPrecedentDataComponent,
		RequisitionTextAreasComponent,
		RequisitionTextColumnComponent,
		NewCustomRequisitionModalComponent,
		ConfirmDeleteCustomRequisitionComponent,
		CustomRequisitionFormComponent,
		EditCustomRequisitionModalComponent,
		NewCustomRequisitionViewComponent,
		RequisitionTagTextValidationDirective,
	],
	exports: [
		RequisitionPrecedentFormComponent,
		RequisitionStatusDropdownComponent,
		NewRequisitionModalComponent,
		TeranetInstrumentsRequisitionComponent,
		TeranetWritsRequisitionComponent,
		NewTeranetRequisitionModalComponent,
		RequisitionPrecedentDataComponent,
		RequisitionTextAreasComponent,
	],
	imports: [
		UiModule,
		CommonModule,
		FormsModule,
		AtomicModule,
		CoreModule,
		MatTooltipModule,
	],
})
export class RequisitionsModule {}
